import { Outlet } from "react-router-dom";
import SiteHeader from "../components/navigation/SiteHeader";
import SiteFooter from "../components/navigation/SiteFooter";

const MainLayout = () => {
  return (
    <div className="site-shell">
      <div className="site-background" />
      <SiteHeader />
      <main className="site-main">
        <Outlet />
      </main>
      <SiteFooter />
    </div>
  );
};

export default MainLayout;